import { configureStore } from "@reduxjs/toolkit";
import companyRegistrationReducer from '../reducers/company-registration/companyRegistrationSlice';
import commanyInsightReducer from '../reducers/company-insight/companyInsightSlice';
import userRegistrationReducer from '../reducers/user-registration/userRegistrationSlice';
import companyOnboardWizardReducer from '../reducers/company-onboard/companyOnboardSlice';
import userSessionStateReducer from '../reducers/user-session/userSessionSlice';

export const store = configureStore({  // configureStore() is being used to create and initialize the store with the provided reducer
    reducer: {
        // Application reducers goes here
        companyRegistrationReducer,
        commanyInsightReducer,
        companyOnboardWizardReducer,
        userRegistrationReducer,
        userSessionStateReducer,
    },
});

export type AppDispatch  = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;